import axios from 'axios'
import store from './store/keyStore'

const api = axios.create({})

api.interceptors.request.use(config => {
  const apiKey = localStorage.getItem('private_key')
  if (apiKey) {
    config.headers['x-api-key'] = apiKey
  }
  config.headers['X-Custom-User-Agent'] = process.env.VUE_APP_userAgent + navigator.userAgent
  return config
})

api.interceptors.response.use(
  response => response,
  async error => {
    
    const message = error?.response?.data?.error?.detail || '';
    const originalRequest = error.config;

    if (!originalRequest._retry && message.toLowerCase().includes("invalid api key")) {
      originalRequest._retry = true;
      try {
        const newKey = await store.dispatch('getPrivateKey')
        this.$store.dispatch('logout')

        error.config.headers['x-api-key'] = newKey
        return api.request(error.config)
      } catch (err) {
        console.error('Failed to refresh API key:', err)
        return Promise.reject(error)
      }
    }
    return Promise.reject(error)
  }
)

export default api